
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ForkIcon extends Vue {
  @Prop({ default: true }) filled!: boolean;
}
